module.exports = __webpack_public_path__ + "static/media/humanitarian-2723672_1920(1.aff428b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/500/humanitarian-2723672_1920(1.jpg
// module id = 966
// module chunks = 0